import React, { useEffect, useState } from "react"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import Nav from "../components/Nav"
import CosmosBackground from "../components/CosmosBackground"
import requests from "../api/requests"
import { useSnackbar } from "react-simple-snackbar"
import { errorSnackBar } from "../components/snackBarOptions"
import { Skeleton } from "@mui/material"
import { useNavigate } from "react-router-dom"
import "./ScheduleScreen.css"

function ScheduleScreen() {
  const [schedule, setSchedule] = useState(null)
  const [loading, setLoading] = useState(true)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const navigate = useNavigate()

  useEffect(() => {
    requests
      .getMonthlySchedule()
      .then((res) => {
        setSchedule(res.data)
        if (!res.data.viewed) {
          requests
            .markScheduleViewed({ reference_month: res.data.reference_month })
            .catch(() => {})
        }
      })
      .catch(() => openErrorSnackbar("Erro ao carregar a programação"))
      .finally(() => setLoading(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="schedule">
      <CosmosBackground />
      <Nav hideSumary />

      <div className="schedule__body">
        <div className="schedule__content">
          <button className="schedule__back" onClick={() => navigate("/")}>
            <div className="episodeScreen__back">
              <ArrowBackIcon /> Voltar
            </div>
          </button>

          {loading && (
            <div className="schedule__card">
              <Skeleton variant="text" width="55%" height={44} style={{ marginBottom: 24, borderRadius: 6 }} />
              <Skeleton variant="text" width="100%" height={18} style={{ marginBottom: 8 }} />
              <Skeleton variant="text" width="92%" height={18} style={{ marginBottom: 8 }} />
              <Skeleton variant="text" width="80%" height={18} style={{ marginBottom: 24 }} />
              <Skeleton variant="text" width="40%" height={22} style={{ marginBottom: 12 }} />
              <Skeleton variant="text" width="100%" height={18} style={{ marginBottom: 8 }} />
              <Skeleton variant="text" width="88%" height={18} style={{ marginBottom: 8 }} />
              <Skeleton variant="text" width="96%" height={18} style={{ marginBottom: 8 }} />
              <Skeleton variant="text" width="75%" height={18} />
            </div>
          )}

          {!loading && !schedule && (
            <div className="schedule__card schedule__empty">
              <p>Nenhuma programação disponível no momento.</p>
            </div>
          )}

          {!loading && schedule && (
            <div className="schedule__card">
              <h1 className="schedule__title">{schedule.title}</h1>
              <div
                className="schedule__body-html"
                dangerouslySetInnerHTML={{ __html: schedule.body_html }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ScheduleScreen
